<script>
  import { createEventDispatcher } from 'svelte';

  export let mobile = false;

  const dispatch = createEventDispatcher();

  function handleSearch(query) {
    return dispatch('search', { query });
  }

  let query;
</script>

{#if mobile}
  <div class="ui action input">
    <input type="text" bind:value={query} placeholder="Search...">
    <button class="ui icon button" on:click={() => handleSearch(query)}>
      <i class="search icon"></i>
    </button>
  </div>
{:else}
  <div class="ui icon input">
    <i class="search icon"></i>
    <input type="text" bind:value={query} placeholder="Search..." on:keypress={(e) => (e.key === 'Enter') && handleSearch(query)} />
  </div>
{/if}

<style>
  .ui.action.input > input {
    width: auto;
  }

  .ui.action.input > .button {
    font-size: 16px;
  }
</style>